import { config } from '@gen2/config';
import { SortOrder } from '@gen2/types/search-condition';
import { AxiosPromise } from 'axios';
import axios from '../axios.request';

export type TContactCompaniesParams = {
  page?: number;
  per_page?: number;
  'filter[search]'?: string;
  'sort[column]'?: 'created_at' | 'company' | 'contact_count';
  'sort[order]'?: SortOrder;
  limit?: number;
};

export type TContactCompany = {
  name: string;
  contact_count: number;
  contacts: Array<{
    id: string;
    first_name: string;
    last_name: string;
    email: string;
    company: string;
  }>;
};

export type TContactCompaniesResponse = {
  data: {
    companies: TContactCompany[];
    meta: {
      current_page: number;
      per_page: number;
      has_more_pages: boolean;
      total: number;
    };
  };
  message: string;
  success: boolean;
};

export const getContactCompanies = (
  params?: TContactCompaniesParams,
): AxiosPromise<TContactCompaniesResponse> => {
  return axios.request({
    url: `${config.apiVersion.v1}/contact-companies`,
    params: {
      page: 1,
      per_page: 25,
      limit: 100,
      ...params,
    },
    method: 'get',
    headers: {
      Accept: 'application/json',
    },
  });
}; 